module.exports = __webpack_public_path__ + "static/media/YUSD.dbe924f2.png";